import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { SustanciaQuimicaSchema } from "../data/SustanciaQuimicaSchema";
import Grid from "./layout/Grid";
import Panel from "./layout/Panel";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import TextField from "./controls/TextField";
import {
  getTouchedFromSchema,
  isInvalid,
  touchFieldsFromErrors,
} from "../utils/forms";
import CheckboxField from "./controls/CheckboxField";
import MeasureField from "./controls/MeasureField";
import Pagination from "./controls/Pagination";
import Button from "./controls/Button";


export function SustanciaQuimicaForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  operacionesUnitarias,
  unidadesCantidad,
  disabled,
}) {
  const { t } = useTranslation();
  const initialTouched =
    page >= 0 ? getTouchedFromSchema(value, SustanciaQuimicaSchema) : {};
  return (
    <Formik
      initialValues={value}
      enableReinitialize={true}
      validationSchema={SustanciaQuimicaSchema}
      validateOnChange={true}
      validateOnMount={page >= 0}
      initialTouched={initialTouched}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
    >
      {(sustanciaQuimicaForm) => (
        <Grid as={<Panel />} className="formulario embebido">
          <Row>
            <Col>
              <Label>{t("sustanciaQuimicaForm.titulo")}</Label>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <TextField
                id="sustanciaQuimica_nombreComercial"
                name="nombreComercial"
                label={t("sustanciaQuimica.nombreComercial")}
                value={sustanciaQuimicaForm.values?.nombreComercial}
                onChange={(event) => sustanciaQuimicaForm.handleChange(event)}
                isInvalid={isInvalid("nombreComercial", sustanciaQuimicaForm)}
                error={t(sustanciaQuimicaForm.errors.nombreComercial)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <TextField
                id="sustanciaQuimica_nombreQuimico"
                name="nombreQuimico"
                label={t("sustanciaQuimica.nombreQuimico")}
                value={sustanciaQuimicaForm.values?.nombreQuimico}
                onChange={(event) => sustanciaQuimicaForm.handleChange(event)}
                isInvalid={isInvalid("nombreQuimico", sustanciaQuimicaForm)}
                error={t(sustanciaQuimicaForm.errors.nombreQuimico)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <TextField
                id="sustanciaQuimica_CAS"
                name="CAS"
                label={t("sustanciaQuimica.CAS")}
                value={sustanciaQuimicaForm.values?.CAS}
                onChange={(event) => sustanciaQuimicaForm.handleChange(event)}
                isInvalid={isInvalid("CAS", sustanciaQuimicaForm)}
                error={t(sustanciaQuimicaForm.errors.CAS)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <CheckboxField
                id="sustanciaQuimica_operacionesUnitarias"
                name="operacionesUnitarias"
                value={sustanciaQuimicaForm.values?.operacionesUnitarias}
                label={t("sustanciaQuimica.operacionesUnitarias")}
                onChange={(event) => sustanciaQuimicaForm.handleChange(event)}
                options={operacionesUnitarias}
                lg={6}
                labelAttr="nombre"
                valueAttr="orden"
                isInvalid={isInvalid(
                  "operacionesUnitarias",
                  sustanciaQuimicaForm,
                )}
                error={t(sustanciaQuimicaForm.errors.operacionesUnitarias)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <MeasureField
                id="sustanciaQuimica_cantidad"
                name="cantidad"
                label={t("sustanciaQuimica.cantidad")}
                value={sustanciaQuimicaForm.values?.cantidad}
                onChange={(event) => sustanciaQuimicaForm.handleChange(event)}
                units={unidadesCantidad}
                isInvalid={isInvalid("cantidad", sustanciaQuimicaForm)}
                error={t(sustanciaQuimicaForm.errors.cantidad)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row style={{ display: "flex", flexWrap: "wrap" }}>
            <Col lg={6}>
              <Pagination
                sm
                page={page}
                pages={pages}
                onChange={(event) => select(event.target.value)}
              />
            </Col>
            <Col lg={6}>
              <span
                style={{
                  float: "right",
                  alignContent: "center",
                }}
              >
                {page !== -1 && (
                  <Button
                    sm
                    variant="success"
                    value={t("sustanciaQuimicaForm.nuevo")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disalbed={disabled}
                  />
                )}
                {page !== -1 && (
                  <Button
                    sm
                    variant="danger"
                    value={t("sustanciaQuimicaForm.eliminar")}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(page);
                    }}
                    disabled={disabled}
                  />
                )}
                <Button
                  sm
                  variant="primary"
                  value={t("sustanciaQuimicaForm.guardar")}
                  onClick={(event) => {
                    event.preventDefault();
                    sustanciaQuimicaForm.validateForm().then((errors) => {
                      if (
                        touchFieldsFromErrors(errors, sustanciaQuimicaForm)
                      ) {
                        return;
                      }
                      sustanciaQuimicaForm.submitForm();
                    });
                  }}
                  disabled={disabled}
                />
                {page === -1 && pages > 0 && (
                  <Button
                    sm
                    variant="default"
                    value={t("sustanciaQuimicaForm.cancelar")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(0);
                    }}
                    disabled={disabled}
                  />
                )}
              </span>
            </Col>
          </Row>
        </Grid>
      )}
    </Formik>
  );
}
